export const GEOLOCATION_AVAILABILITY_TYPES = ['AVAILABLE', 'UNAVAILABLE'] as const

export type GeolocationAvailabilityType = (typeof GEOLOCATION_AVAILABILITY_TYPES)[number]

export type GeolocationApiModel = {
  lat: number
  lng: number
  radius: number
  availabilityType?: GeolocationAvailabilityType
  name?: string
}

export type LeafletGeolocationApiModel = GeolocationApiModel & {
  availabilityType: GeolocationAvailabilityType
}
